import { NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnsureModuleLoadedOnceGuard } from './ensure-module-loaded-once.guard';
import { AppConfig } from './config/app.config';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthentificationInterceptor } from './interceptor/AuthentificationInterceptor';

export function initializeApp(appConfig: AppConfig) {
	return () => appConfig.load();
}


@NgModule({
  exports: [],
  declarations: [],
  imports: [
    CommonModule
	],
  providers: [
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthentificationInterceptor,
      multi: true
    }
  ]
})

export class CoreModule extends EnsureModuleLoadedOnceGuard {    // Ensure that CoreModule is only loaded into AppModule

	// Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		super(parentModule);
	}

}
